// extracted by mini-css-extract-plugin
export default {"input":"dm-input","textarea":"dm-textarea","input_size_compact":"dm-input_size_compact","input_size_small":"dm-input_size_small","input_size_large":"dm-input_size_large"};